import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

export type ViewInfo = {
    icon: JSX.Element;
    label: string;
};

type BreadCrumbItemProps = {
    label: string;
    icon?: JSX.Element;
    isHighlighted?: boolean;
    to?: string;
    ariaLabel?: string;
};

const BreadCrumbItem = ({ label, icon, isHighlighted = false, to, ariaLabel }: BreadCrumbItemProps) => {
    const content = <>{icon ? icon : null}<Text as={isHighlighted ? 'h3' : 'span'}>{label}</Text></>;

    return to
        ? <LinkWrapper to={to} aria-label={ariaLabel} $isHighlighted={isHighlighted}>{content}</LinkWrapper>
        : <Wrapper $isHighlighted={isHighlighted}>{content}</Wrapper>;
};

const Text = styled.span`
    font-size: 12px;
    font-weight: 400;
    margin: 0;
    padding: 8px;
    border-radius: 8px;
    /* reset the global h3 styles of @gmg/gmg-react-components when rendered as a heading */
    color: inherit;
    text-transform: none;
`;

const wrapperStyles = css<{ $isHighlighted: boolean }>`
    display: flex;
    align-items: center;
    overflow-wrap: anywhere;
    ${props => props.$isHighlighted && css`color: ${props.theme.colors.highlight};`}
`;

const Wrapper = styled.div<{ $isHighlighted: boolean }>`
    ${wrapperStyles}
`;

const LinkWrapper = styled(Link)<{ $isHighlighted: boolean }>`
    ${wrapperStyles}
    text-decoration: none;

    &:hover ${Text} {
        background-color: ${props => props.theme.colors.highlightLight};
        color: ${props => props.theme.colors.highlight};
    }
`;

export default BreadCrumbItem;
